import {
  Component,
  Input,
  forwardRef,
  HostListener,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

@Component({
  selector: "ema-select-search",
  templateUrl: "./ema-select-search.component.html",
  styleUrls: ["./ema-select-search.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmaSelectSearchComponent),
      multi: true,
    },
  ],
})
export class EmaSelectSearchComponent implements ControlValueAccessor {
  list = [];
  temp_list = [];
  keyword = "";
  _img: any;
  _label: any;
  _uid: any;

  @Output() afterChange = new EventEmitter();
  @Output() changeDetect = new EventEmitter<any>();
  @Output() notFoundEvent = new EventEmitter<any>();
  @ViewChild("input", { static: false }) input: ElementRef;
  @Input("size") size;
  @Input("items") set items(value) {
    this.list = value;
    this.temp_list = value;
  }
  @Input("img") img;
  @Input("label") label;
  @Input("uid") uid;
  onChange: any = () => {};
  onTouch: any = () => {};
  value: any = "Select";
  shown = false;
  constructor(private ele: ElementRef) {}

  ngOnChanges() {
    this._label =
      typeof this.label !== "undefined" &&
      this.label !== "" &&
      this.label !== null
        ? this.label
        : "name";
    this._img =
      typeof this.img !== "undefined" && this.img !== "" ? this.img : "img";
    this._uid =
      typeof this.uid !== "undefined" && this.uid !== "" ? this.uid : "id";
    this.value = "Select";
  }
  writeValue(value) {
    if (value) {
      this.temp_list.map((x) => {
        if (x[this._uid] == value) {
          this.value = x[this._label];
        }
      });
    }
  }
  registerOnChange(fn: any) {
    //console.log("Registering changes----");
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
  search(e) {
    let val = "";
    if (e != null && e != undefined) {
      val = e.toLowerCase().trim();
    }

    // 🔹 Si no se escribió nada, restaurar lista original
    if (val == "") {
      this.list = [];
      for (let i = 0; i < this.temp_list.length; i++) {
        this.list.push(this.temp_list[i]);
      }
      this.notFoundEvent.emit(true);
      return;
    }

    // 🔹 Filtrar manualmente los elementos que contienen el texto
    const filtered = [];
    for (let i = 0; i < this.temp_list.length; i++) {
      const x = this.temp_list[i];
      let label = "";
      if (x[this._label] != null && x[this._label] != undefined) {
        label = x[this._label].toString().toLowerCase();
      }

      if (label.indexOf(val) != -1) {
        filtered.push(x);
      }
    }

    // 🔹 Asignar resultados
    this.list = filtered;

    // 🔹 Enviar evento según haya resultados o no
    if (filtered.length != 0) {
      this.notFoundEvent.emit(true);
    } else {
      this.notFoundEvent.emit(false);
    }
  }

  select(item) {
    //console.log("item seleccionado.", item);
    //this.onChange(item[this._label]);
    this.onChange(item);
    this.value = item[this._label];
    this.shown = false;
    this.changeDetect.emit(item);
  }
  show() {
    this.shown = this.shown ? false : true;
    setTimeout(() => {
      this.input.nativeElement.focus();
    }, 200);
  }
  @HostListener("document:click", ["$event"]) onClick(e) {
    // console.log("Seleccionando.....");
    if (!this.ele.nativeElement.contains(e.target)) {
      this.shown = false;
    }
  }
}
